import { Component, ErrorInfo, ReactNode } from 'react';

import { ErrorBoundaries } from 'components';
import { newRelicMonitoringService } from 'services';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    newRelicMonitoringService.addError(error, {
      errorInfo,
      message: 'error_boundary_selfservice',
    });
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorBoundaries.ReloadPage title='Tivemos um problema' />;
    }

    return this.props.children;
  }
}
